// src/hooks/useMatchEvents.ts
import { useEffect } from "react";
import eventManager from "./eventManager";
import {IMatchEvents} from "../types/types";


export default function useMatchEvents(handlers: IMatchEvents) {
    useEffect(() => {
        Object.entries(handlers).forEach(([event, handler]) => {
            if (handler) {
                eventManager.on(event, handler);
            }
        });

        return () => {
            Object.entries(handlers).forEach(([event, handler]) => {
                if (handler) {
                    eventManager.off(event, handler);
                }
            });
        };
    }, [handlers]);
}
